// 图片轮播
$(function () {
  const init = ($imgs) => {
    let leftIndex = 0;
    const classSync = () => {
      //重置每一张图片的class
      if (!$imgs.get(leftIndex)) {
        leftIndex = 0;
      }
      let middleIndex = leftIndex + 1;
      if (!$imgs.get(middleIndex)) {
        middleIndex = 0;
      }
      let rightIndex = middleIndex + 1;
      if (!$imgs.get(rightIndex)) {
        rightIndex = 0;
      }
      $imgs.removeClass("left middle right");
      $imgs.eq(leftIndex).removeClass("middle right").addClass("left");
      $imgs.eq(middleIndex).removeClass("left right").addClass("middle");
      $imgs.eq(rightIndex).removeClass("left middle").addClass("right");
    };
    const showNext = () => {
      //显示下一张图片
      leftIndex++;
      classSync();
    };
    classSync();
    //----------------------------------------------------------------------
    const showPrev = () => {
      //显示上一张图片
      leftIndex--;
      if (!$imgs.get(leftIndex)) {
        leftIndex = $imgs.length - 1;
      }
      classSync();
    };
    //--------------------------------------------------------------------------
    const $imgList = $imgs.parents(".img-list");
    const bindMouseMove = require("../../utils/bindMobileMove");

    bindMouseMove($imgList);
    let lastMoveTime = 0;
    $imgList.on("mouseLeftMove", () => {
      if ($.now() - lastMoveTime > 500) {
        showNext();
        lastMoveTime = $.now();
        restartInterval();
      }
    });
    $imgList.on("mouseRightMove", () => {
      if ($.now() - lastMoveTime > 500) {
        showPrev();
        lastMoveTime = $.now();
        restartInterval();
      }
    });
    // //点击某个图片 把它放到最中间
    // $imgs.on('click', function () {
    //   const middleIndex = $imgs.index($(this));
    //   console.log(middleIndex);
    //   leftIndex = middleIndex - 1;
    //   classSync();
    // });
    //
    const restartInterval = (() => {
      let interval = null;
      return () => {
        clearInterval(interval);
        interval = setInterval(showNext, 50000000);
      };
    })();
    restartInterval();
  };

  //数字乡村建设 图片轮播
  init($(".app-szxc-block .module-index-1 .img-item"));
  //村里办 图片轮播
  init($(".app-szxc-block .module-index-2 .img-item"));
  // 数字工厂  图片轮播
  init($(".app-cjmy-four .img-list .img-item"));
});
